import React, {useEffect, useState} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom'
import {ThemeSwitcherProvider} from 'react-css-theme-switcher';
import store from './store';
import history from './history'
import Layouts from './layouts'
import {THEME_CONFIG} from './configs/AppConfig';
import './lang'
import './assets/table.css';
import {PermifyProvider} from "@permify/react-role";

const themes = {
    dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
    light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
    const [bypassActive, setBypassActive] = useState(false);
    const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE === 'true';
    const secretToken = process.env.REACT_APP_MAINTENANCE_SECRET;

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('secret');

        if (token === secretToken) {
            localStorage.setItem('maintenance_bypass', 'true');
            setBypassActive(true);

            // Nettoyer l'URL
            const newUrl = window.location.pathname + window.location.hash;
            window.history.replaceState({}, '', newUrl);
        } else if (token === 'reset') {
            // Permettre de réinitialiser le bypass
            localStorage.removeItem('maintenance_bypass');
            setBypassActive(false);
        } else {
            const storedBypass = localStorage.getItem('maintenance_bypass');
            setBypassActive(storedBypass === 'true');
        }
    }, [secretToken]);

    const shouldShowMaintenance = isMaintenanceMode && !bypassActive;

    if (shouldShowMaintenance)
        return ""

    return (
        <div className="App">
            <PermifyProvider>
                <Provider store={store}>
                    <BrowserRouter history={history}>
                        <ThemeSwitcherProvider
                            themeMap={themes}
                            defaultTheme={THEME_CONFIG.currentTheme}
                            insertionPoint="styles-insertion-point"
                        >
                            <Layouts />
                        </ThemeSwitcherProvider>
                    </BrowserRouter>
                </Provider>
            </PermifyProvider>
        </div>
    );
}

export default App;
